<template>
  <div class="trading-box">
    <a-card :bordered="false" :bodyStyle="{ padding: 0 }">
      <div class="head-opera-box">
        <div class="head-opera-btn">
          <a-button class="editable-add-btn" @click="moreUpper"
            >批量上架</a-button
          >
          <a-button class="editable-add-btn" type="danger" @click="moreDelete"
            >批量删除</a-button
          >
        </div>
        <a-input-search
          placeholder="请输入yy号"
          @search="onSearch"
          enterButton="搜索"
          style="width:500px"
        />
      </div>
      <a-table
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: haoSelect
        }"
        :columns="columns"
        @change="change"
        :dataSource="haolist"
        :pagination="pagination"
        :rowKey="haolist => haolist.hao"
      >
        <div slot="status" slot-scope="record">
          <a-tag color="gray">
            <span v-statusHao="record.hao_status"></span>
          </a-tag>
        </div>
        <div slot="action" slot-scope="record" class="opera-btn-box">
          <a-button
            type="primary"
            size="small"
            href="javascript:;"
            @click="showDetailModify(record)"
            >修改</a-button
          >
          <a-popconfirm
            :title="'你确定要上架YY号：' + record.hao + '吗?'"
            okText="上架"
            cancelText="取消"
            @confirm="moreUpperSure(record)"
          >
            <a-button type="primary" size="small" href="javascript:;"
              >上架</a-button
            >
          </a-popconfirm>
          <a-popconfirm
            :title="'你确定要删除YY号：' + record.hao + '吗?'"
            okText="删除"
            okType="danger"
            cancelText="取消"
            @confirm="moreDeleteSure(record)"
          >
            <a-button type="primary" size="small" href="javascript:;"
              >删除</a-button
            >
          </a-popconfirm>
        </div>
      </a-table>
      <!-- 上架提示 -->
      <a-modal
        title="上架提示"
        :visible="visibleUpper"
        @ok="moreUpperSure"
        okText="上架"
        :confirmLoading="confirmLoading"
        @cancel="downMoreCancel"
      >
        <p>{{ downContent }}</p>
      </a-modal>
      <!-- 详情提示 -->
      <a-modal
        title="详情提示"
        :visible="visibleDelete"
        @ok="moreDeleteSure"
        okType="danger"
        okText="删除"
        :confirmLoading="confirmLoading"
        @cancel="downMoreCancel"
      >
        <p>{{ downContent }}</p>
      </a-modal>
      <!-- 详情提示 -->
      <a-modal
        title="发货"
        :visible="visibleModify"
        @ok="haoModify"
        okText="修改"
        @cancel="downMoreCancel"
        :confirmLoading="confirmLoading"
      >
        <a-form>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="YY号"
          >
            <a-input disabled :value="haoInfo.hao" />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="等级"
          >
            <a-input placeholder="请输入等级" v-model="haoGrade" />
          </a-form-item>
          <a-form-item
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            label="价格"
          >
            <a-input placeholder="请输入价格" v-model="haoPrice" />
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import { HAO_stock_query, HAO_upper, HAO_delete, HAO_modify } from "@/api/hao";
import "@/utils/directive";
const columns = [
  {
    title: "YY号",
    dataIndex: "hao"
  },
  {
    title: "等级",
    dataIndex: "grade"
  },
  {
    title: "价格",
    dataIndex: "price"
  },
  {
    title: "状态",
    key: "hao_status",
    scopedSlots: { customRender: "status" },
    align: "center"
  },
  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "action" },
    align: "center"
  }
];
export default {
  data() {
    return {
      haolist: [],
      columns,
      current: 1,
      total: 0,
      limit: 10,
      selectedRowKeys: [],
      searchValue: "",
      visibleUpper: false,
      visibleDelete: false,
      visibleModify: false,
      downContent: "",
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      haoInfo: {},
      haoPrice: "",
      haoGrade: "",
      pagination: {
        total: 0,
        pageSize: 10,
        showTotal: total => `总数: ${total} 条`
      }
    };
  },
  computed: {
    rowSelection() {
      return {
        type: "checkbox"
      };
    }
  },
  mounted() {
    this.getHao({
      skip: 0,
      limit: 10
    });
  },
  methods: {
    getHao: function(_obj) {
      HAO_stock_query(_obj)
        .then(response => {
          this.selectedRowKeys = [];
          this.haolist = response.res.data;
          this.pagination.total = response.res.total;
          this.pagination.limit = response.res.limit;
          //this.current = response.res.skip / this.limit + 1;
        })
        .catch(() => {});
    },
    haoSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    handleDown: function() {
      if (this.selectedRowKeys.length > 0) {
        this.downContent = "";
        this.downContent += "你确定要下架这些号码吗?";
        this.visible = true;
      } else {
        this.$notification.warning({
          message: "提示",
          description: "请选择要下架的号码"
        });
      }
    },
    onSearch: function(value) {
      this.searchValue = value;
      this.getHao({
        skip: 0,
        limit: 10,
        hao: this.searchValue
      });
    },
    onChange: function(page, pageSize) {
      this.getHao({
        skip: (page - 1) * pageSize,
        limit: pageSize,
        hao: this.searchValue
      });
    },
    downMoreCancel: function() {
      this.visibleUpper = false;
      this.visibleDelete = false;
      this.visibleModify = false;
    },
    showDetailModify: function(e) {
      this.haoInfo = e;
      this.haoPrice = e.price;
      this.haoGrade = e.grade;
      this.visibleModify = true;
    },
    moreUpper: function() {
      if (this.selectedRowKeys.length > 0) {
        this.downContent = "";
        this.downContent += "你确定要上架这些号码吗?";
        this.visibleUpper = true;
      } else {
        this.$notification.warning({
          message: "提示",
          description: "请选择要上架的号码"
        });
      }
    },
    moreUpperSure: function(item) {
      let _arr = [];
      if ("hao" in item) {
        _arr.push(item.hao.toString());
      } else {
        this.selectedRowKeys.forEach(item => {
          _arr.push(item.toString());
        });
      }
      //this.confirmLoading = true;
      HAO_upper({
        haoList: _arr
      })
        .then(() => {
          this.$notification.success({
            message: "提示",
            description: "上架成功"
          });
          this.confirmLoading = false;
          this.visibleUpper = false;
          if (
            (this.total - _arr.length) % this.limit === 0 &&
            (this.total - _arr.length) / this.limit === this.current - 1
          ) {
            this.getHao({
              skip: (this.current - 2) * this.limit,
              limit: this.limit,
              hao: this.searchValue
            });
          } else {
            this.getHao({
              skip: (this.current - 1) * this.limit,
              limit: this.limit,
              hao: this.searchValue
            });
          }
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    change: function(_data) {
      //翻页
      let _skip = (_data.current - 1) * _data.pageSize;
      this.getHao({
        limit: this.pagination.pageSize,
        skip: _skip,
        hao: this.searchValue
      });
    },
    moreDelete: function() {
      if (this.selectedRowKeys.length > 0) {
        this.downContent = "";
        this.downContent += "你确定要删除这些号码吗?";
        this.visibleDelete = true;
      } else {
        this.$notification.error({
          message: "提示",
          description: "请选择要删除的号码"
        });
      }
    },
    moreDeleteSure: function(item) {
      let _arr = [];
      if ("hao" in item) {
        _arr.push(item.hao.toString());
      } else {
        this.selectedRowKeys.forEach(item => {
          _arr.push(item.toString());
        });
      }
      //this.confirmLoading = true;
      HAO_delete({
        haoList: _arr
      })
        .then(() => {
          this.$notification.success({
            message: "提示",
            description: "删除成功"
          });
          this.confirmLoading = false;
          this.visibleDelete = false;
          if (
            (this.total - _arr.length) % this.limit === 0 &&
            (this.total - _arr.length) / this.limit === this.current - 1
          ) {
            this.getHao({
              skip: (this.current - 2) * this.limit,
              limit: this.limit,
              hao: this.searchValue
            });
          } else {
            this.getHao({
              skip: (this.current - 1) * this.limit,
              limit: this.limit,
              hao: this.searchValue
            });
          }
        })
        .catch(() => {
          this.confirmLoading = false;
          this.$notification.success({
            message: "提示",
            description: "删除失败"
          });
        });
    },
    haoModify: function() {
      //return
      HAO_modify({
        h_id: this.haoInfo.h_id,
        hao: this.haoInfo.hao,
        price: Number(this.haoPrice),
        grade: Number(this.haoGrade)
      })
        .then(() => {
          this.$notification.success({
            message: "提示",
            description: "修改成功"
          });
          this.confirmLoading = false;
          this.visibleModify = false;
          this.getHao({
            skip: (this.current - 1) * this.limit,
            limit: this.limit,
            hao: this.searchValue
          });
        })
        .catch(() => {
          this.confirmLoading = false;
          this.$notification.success({
            message: "提示",
            description: "修改失败"
          });
        });
    }
  }
};
</script>

<style lang="less" scoped>
.trading-box {
  .head-opera-box {
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;
    .head-opera-btn .ant-btn {
      margin-right: 10px;
    }
  }
  .opera-btn-box {
    a {
      margin: 0 5px;
    }
  }
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    padding: 10px 5px;
  }
}
</style>
